import Home from '../src/Pages/Home/Home';
import './App.css';

function App() {
  return (
    <div className="App mt-20">
     <Home/>
    </div>
  );
}

export default App;
